

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class CheckedRed extends Vue {
  @Prop({ default: '16' }) size!: string;
  @Prop({ default: '#E32B2E' }) fillColor!: string;
}
